// extracted by mini-css-extract-plugin
module.exports = {"tablet":"680px","laptop":"980px","desktop":"1180px","search":"page_search__cmWmo","header":"page_header__BbkwY","termsOfUse":"page_termsOfUse__r6F8c"};